import React from 'react';
import PropTypes from 'prop-types';
import { matchPath, useLocation } from 'react-router-dom';
import NotificationContainer from './containers/notification/NotificationsContainer.jsx';
import SiteHeader from './components/SiteHeader.jsx';
import SessionExpiredModalContainer from './containers/auth/SessionExpiredModalContainer.jsx';
import ProjectDuplicationsWatcher from './containers/projectDuplications/ProjectDuplicationsWatcher.jsx';
import InitiativeCopyWatcher from './containers/initiativeDuplications/InitiativeCopyWatcher.jsx';

// Routes that should hide navigation
const hideNavRoutes = ['/:slug/:initiativeType/:initiativeId/preview'];

// Routes that should hide entire header
const hideHeaderRoutes = [
  '/',
  '/forgot-password',
  'reset-password',
  'accept-invitation',
];

const Layout = ({ children }) => {
  const location = useLocation();

  const hideNav = hideNavRoutes.some((pattern) =>
    matchPath(pattern, location.pathname)
  );

  const hideHeader = hideHeaderRoutes.some((pattern) =>
    matchPath(pattern, location.pathname)
  );
  return (
    <div
      style={{ minHeight: '101vh', display: 'flex', flexDirection: 'column' }}
    >
      <NotificationContainer />
      {!hideHeader && <SiteHeader hideNav={hideNav} />}
      {!hideHeader && <ProjectDuplicationsWatcher />}
      {!hideHeader && <InitiativeCopyWatcher />}
      <main role="main">{children}</main>
      {location.pathname !== '/forgot-password' && (
        <SessionExpiredModalContainer />
      )}
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;
